import { Component } from 'react'
import PropTypes from 'prop-types'
import { map, sortBy } from 'lodash-es'
import CommentListItem from './CommentListItem'

export default class CommentsList extends Component {
  static propTypes = {
    comments: PropTypes.object.isRequired,
  }

  getCommentItems() {
    const { comments } = this.props
    const sortedComments = sortBy(Object.values(comments), comment => new Date(comment.created_at))
    return map(sortedComments, comment => {
      const key = `comment-${comment.id}`
      return <CommentListItem key={key} comment={comment} />
    })
  }

  getContent() {
    const { comments } = this.props
    if (Object.keys(comments).length === 0) {
      return <p>There aren&apos;t any comments yet.</p>
    } else {
      const commentItems = this.getCommentItems()
      return <ol className="comments-list">{commentItems}</ol>
    }
  }

  render() {
    return (
      <section className="timeline-comments__comments">
        <h1 className="heading timeline-comments__heading">Comments</h1>
        {this.getContent()}
      </section>
    )
  }
}
